<form
  class="invite-field"
  [formGroup]="form"
  [class.focused]="focused()"
  [class.textarea-style]="textareaStyle"
  autocomplete="off"
  [class.no-border]="noBorder"
>
  <div class="email-area" [class.vertically-center]="verticallyCenter">
    @for (email of emails(); track $index) {
      <div class="email" [class.invalid]="isInvalid(email, $index)" [appTooltip]="getError(email, $index)">
        <span>{{ email }}</span>
        <button
          appButton
          type="button"
          name="remove-email"
          location="emais-entry-field"
          (click)="removeEmail($index)"
          height="-2"
          [iconButton]="true"
          [color]="isInvalid(email, $index) ? 'simple-warn' : 'simple'"
        >
          <app-svg src="/assets/icons/16/cross.svg"></app-svg>
        </button>
      </div>
    }
    <input
      type="email"
      formControlName="emails"
      (keypress)="onKeyPress($event)"
      (keydown)="onKeyDown($event)"
      [placeholder]="emails().length || noPlaceholder ? '' : customPlaceholder || 'Enter or paste a list of emails...'"
      data-test-id="emails-input"
      (paste)="parseEmails()"
      enterkeyhint="next"
      (focus)="focused.set(true)"
      (focus)="focus()"
      (blur)="blur()"
      id="input-emails"
      autocomplete="off"
      data-1p-ignore="true"
      data-lpignore="true"
    />
    <label for="input-emails"></label>
  </div>
  <ng-content></ng-content>
</form>
